module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate Kessler\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("As a child "), _c('B', [_vm._v("Kate Kessler")]), _vm._v(" seemed to have a knack for finding trouble, and for it finding her. A former delinquent, Kate now prefers to write about trouble rather than cause it, and spends her days writing about why people do the things they do. She lives in New England with her husband.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10JSi9u/images/9780316302487.jpg?1733067595886",
      "alt": "This image is the cover for the book It Takes One, The Audrey Harte Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("It Takes One, The Audrey Harte Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("\"Deliciously twisted . . . Kate Kessler's positively riveting "), _c('i', [_vm._v("It Takes One")]), _vm._v(" boasts a knockout concept and a thoroughly unique and exciting protagonist, a savvy criminal psychologist with murderous skeletons in her own closet.\" -- "), _c('i', [_vm._v("Sara Blaedel")]), _vm._v(", #1 internationally bestselling author"), _c('b', [_c('br'), _c('br'), _vm._v("Criminal psychologist Audrey Harte is returning home after seven years. "), _c('br'), _c('br'), _vm._v("Less than 24 hours later, her best friend is murdered. "), _c('br'), _c('br'), _vm._v("Now, Audrey is both the prime suspect and the only person who can solve the case. . . "), _c('br'), _c('br'), _c('i', [_vm._v("It Takes One")]), _vm._v(" is the opening to a thriller series where a criminal psychologist uses her own dark past to help law enforcement catch dangerous killers.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Redhook\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0